import React, { useEffect, useContext, useState } from 'react';
import HTMLReactParser from 'html-react-parser/lib/index';
import { useTranslation } from 'react-i18next';
import './termsandconditions.css';
import MetricsContext from '../../context/MetricsContext';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';
import BaseLayout from '../../commons/BaseLayout';

function TermsAndConditions() {
  const { t } = useTranslation();
  const { updateUserMetric } = useContext(MetricsContext);
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');

  const sessionId = localStorage.getItem('sessionId');
  useEffect(() => {
    updateUserMetric({
      name: PageNames.TERMS_PAGE,
      pageType: PageTypes.DEFAULT,
    });
  }, [sessionId]);

  return (
    <BaseLayout goBack header headerLogo onVersionChange={setActiveVersion} sidebar>
      <div className="termsbody">{HTMLReactParser(t('legal.terms.body'))}</div>
    </BaseLayout>
  );
}

export default TermsAndConditions;
